import styled, { css, keyframes } from "styled-components";

export const UserTimer3Wrapper = styled.div`
  overflow: hidden;
  padding: 30px;
  background: #0a092ecc;
  width: 1080px;
  height: 1920px;
  box-sizing: border-box;
`;

export const Timer3Background = styled.div<{ backgroundImage: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ backgroundImage }) =>
    `url(${backgroundImage}) lightgray 50% / cover no-repeat`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(2.5px);
  opacity: 0.4;
`;

export const UserTimer3TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 70px;
  z-index: 2;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 35px;
`;

export const UserTimer3TimerInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 38px;
  position: relative;

  > .now-level {
    width: 955px;
    height: 88px;
    border-radius: 35px;
    background: #303030;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 60px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;

    > .break-text {
      color: #f00;
    }
  }

  > .time {
    color: #b6ffac;
    font-family: Pretendard;
    font-size: 305px;
    font-weight: 900;
    height: 364px;
  }

  > .time.break {
    color: #f00;
  }
`;

export const UserTimer3BreakWrapper = styled.div`
  width: 1104px;
  height: 93px;
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 35px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  > .title {
    color: #7a7a7b;
    text-align: center;
    font-family: Pretendard;
    font-size: 45.203px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .value {
    width: 218px;
    color: #fff;
    font-family: Pretendard;
    font-size: 45.203px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
  }
`;

export const UserTimer3BlindWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 10px;
  width: 1020px;
`;

export const UserTimer3NowBlindWrapper = styled.div`
  width: 100%;
  height: 137px;
  display: flex;
  flex-direction: row;
  gap: 39px;
  border-radius: 35px;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  > .title {
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 45px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
  }

  > .title.next {
    color: #979797;
  }

  > .value.next {
    color: #979797;
  }

  > .value {
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 70px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
  }
`;

export const UserTimer3RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const UserTimer3RightTop = styled.div`
  width: 736px;
  height: 781px;
  border-radius: 35px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  position: relative;
  > img {
    position: absolute;
    bottom: 30px;
    left: 140px;
  }
`;

export const UserTimer3NoticeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: 30px;
    margin-left: 30px;
  }

  > .value-wrapper {
    margin-left: 30px;
    margin-top: 20px;
    border-radius: 15.04px;
    background: #363636;
    width: 636px;
    height: 600px;
    padding: 20px;

    > .value {
      width: 100%;
      height: 100%;
      color: #fff;
      font-family: "Termina Test";
      font-size: 30px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-overflow: ellipsis; /* 초과된 부분에 "..." 표시 */
      overflow-wrap: break-word;
      overflow: hidden; /* 내용이 넘치면 잘림 */
      display: -webkit-box; /* 웹킷 박스 모델로 설정 */
      -webkit-line-clamp: 15; /* 15줄로 제한 */
      -webkit-box-orient: vertical; /* 블록 방향 설정 */
    }
  }
`;

export const UserTimer3PrizeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: 30px;
    margin-left: 30px;
  }

  > .list-wrapper {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 0 30px;
    width: calc(100% - 60px);
  }
`;

export const UserTimer3PrizeItemTop3 = styled.div<{ isTop3: boolean }>`
  padding: ${({ isTop3 }) => (isTop3 === true ? "17px 20px" : "6px 20px")};
  width: calc(100% - 40px);
  border-radius: 15.04px;
  ${({ isTop3 }) => isTop3 === true && "  background: #303030;"}

  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  > .rank {
    font-family: Pretendard;
    font-size: 30px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    color: #bdbdbd;
  }

  > .rank.high {
    background: linear-gradient(
      95deg,
      #d9ff00 0.13%,
      #fff 18.47%,
      #4bf95f 43.3%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  > .prize-box {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    > .prize {
      padding: 8px 15px;
      color: ${({ isTop3 }) => (isTop3 === true ? "white" : "#BDBDBD")};
      text-align: center;
      font-family: Pretendard;
      font-size: 25px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      font-variant-numeric: tabular-nums;

      > span {
        margin-right: 15px;
        font-size: 55px;
        letter-spacing: 1px;
      }
    }

    > .sub-prize {
      padding: 6px 15px;
      border-radius: 10px;
      background: linear-gradient(
        103deg,
        #6c36d6 -22.02%,
        #955fff 54.56%,
        #ccb2ff 102.58%
      );
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
`;

export const UserTimer3InfoWrapper = styled.div`
  z-index: 2;
  margin-top: 20px;
  box-sizing: border-box;
  width: 100%;
  height: 866px;
  border-radius: 35px;
  gap: 10px;
  position: relative;
  display: flex;
  justify-content: space-between;

  > img {
    position: absolute;
    bottom: 30px;
    left: 140px;
  }
`;

export const Timer3LeftItemWrapper = styled.div`
  position: relative;
  width: 505px;
  box-sizing: border-box;
  padding-left: 30px;
  height: 158px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  justify-content: center;
  background: #12121280;

  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 25px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .value {
    color: #fff;
    font-family: "Termina Test";
    font-size: 45px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const Timer3PrizeWrapper = styled.div`
  z-index: 2;
  padding: 30px;
  box-sizing: border-box;
  width: 535px;
  height: 866px;
  border-radius: 35px;
  background: #00000080;
  box-shadow: 0px 3.86px 3.86px 0px #00000040;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > img {
    position: absolute;
    bottom: 30px;
    left: 140px;
  }
`;

export const Timer3PrizeListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .list-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
  }
`;

const slideAnimation = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  15% {
    transform: translateY(0);
    opacity: 1;
  }
  85% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-30%);
    opacity: 0;
  }
`;

export const Timer3PrizeItem = styled.div<{ length: number }>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  ${({ length }) =>
    length >= 11 &&
    css`
      animation: ${slideAnimation} 9s linear infinite;
    `}

  > .rank {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const Timer3PrizeItemTop3 = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;

  > .rank {
    font-family: Pretendard;
    font-size: 45px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    background: linear-gradient(
      95deg,
      #d9ff00 0.13%,
      #fff 18.47%,
      #4bf95f 43.3%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const Timer3NoticeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .value-wrapper {
    border-radius: 15.04px;
    background: #363636;
    width: 636px;
    height: 663px;
    padding: 20px;
    color: #fff;
    font-family: "Termina Test";

    > .value {
      width: 100%;
      height: 100%;
      font-size: 30px;
      font-style: normal;
      font-weight: 700;
      line-height: 1.3;
      overflow: hidden;
      text-overflow: ellipsis; /* 초과된 부분에 "..." 표시 */
      overflow-wrap: break-word;
      display: -webkit-box; /* 웹킷 박스 모델로 설정 */
      -webkit-line-clamp: 17;
      -webkit-box-orient: vertical; /* 블록 방향 설정 */
    }
  }
`;

export const Timer3PrizeBoxWrapper = styled.div<{ subPrizeFont: number }>`
  width: 358px;
  height: 59px;
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
  border-radius: 10px;
  color: #fff;
  text-align: right;
  font-family: Pretendard;
  font-size: 23px;
  font-weight: 700;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden; /* 넘치는 텍스트 숨김 */
  text-overflow: ellipsis; /* 넘칠 경우 말줄임 표시 */
  white-space: normal; /* 줄바꿈 허용 */
  overflow-wrap: break-word;
  font-variant-numeric: tabular-nums;

  > .sub {
    padding: 6px 15px;
    border-radius: 10px;
    background: linear-gradient(
      103deg,
      #6c36d6 -22.02%,
      #955fff 54.56%,
      #ccb2ff 102.58%
    );
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: ${({ subPrizeFont }) => (subPrizeFont ? subPrizeFont : 20)}px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > span {
    margin-right: 15px;
    font-size: 55px;
    letter-spacing: 1px;
  }
`;
